import { useState } from 'react'
import { Button, Chip } from '@mui/material'
import axiosInstance from '../../../utils/axiosInstance'
import { setTriggerAppUsersRefetch } from '../../../store/slices/general'
import { useDispatch, useSelector } from '../../../store/store'

interface VerifyEmailButtonProps {
  id: string
  // null: unknown (no SuperTokens account linked, or it could not be read)
  isEmailVerified: boolean | null
}

// Lets an admin mark an account's email as verified when the verification mail never
// arrived. Everyone else only sees the status.
const VerifyEmailButton = ({ id, isEmailVerified }: VerifyEmailButtonProps) => {
  const dispatch = useDispatch()
  const { role } = useSelector((state) => state.user.userInfo)
  const [loading, setLoading] = useState(false)

  if (isEmailVerified === null) {
    return <Chip size="small" label="Unknown" />
  }
  if (isEmailVerified) {
    return <Chip size="small" color="success" label="Verified" />
  }
  if (role !== 'admin') {
    return <Chip size="small" color="warning" label="Not verified" />
  }

  const submit = async () => {
    setLoading(true)
    try {
      await axiosInstance.post(`/app-users/verify-email/${id}`)
      dispatch(setTriggerAppUsersRefetch(true))
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button onClick={submit} variant="outlined" color="primary" disabled={loading}>
      Verify email
    </Button>
  )
}

export default VerifyEmailButton
